import React from 'react';

export default class Icon extends React.Component {

  render() {
    let style = {};
    if (this.props.size) {
      style.fontSize = this.props.size + 'px';
    }

    if (this.props.color) {
      style.color = this.props.color;
    }

    return <i className="Icon material-icons" style={style}>{this.props.icon}</i>;
  }

}



// WEBPACK FOOTER //
// ./client/components/Icon.js